'use client';

import { useSchedulerStoreContext } from '@mui/x-scheduler-headless/use-scheduler-store-context';
export function useEventTimelinePremiumStoreContext() {
  const context = useSchedulerStoreContext();
  if (context.instanceName !== 'EventTimelinePremiumStore') {
    throw /* FIXME (minify-errors-in-prod): Unminified error message in production build! */new Error('MUI: useEventTimelinePremiumStoreContext must be used within an <EventTimelinePremium /> component');
  }
  return context;
}